export const aboutData="I am a full-stack developer with proficiency in front-end development using React and React Native. Passionate about beautiful, smooth animations and UI/UX."


export const socials=[{name:"linkedin",url:"https://www.linkedin.com/in/adithya-pai-613747aa/"},{name:"instagram",url:"https://www.instagram.com/arp_0505"}]